import { Fragment, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { Dialog, Transition } from '@headlessui/react'
import GrayButton from './GrayButton';
import GreenButton from './GreenButton';

const CreateOfferModal = (props) => {
    const { isShown, setShown, handleCreateModal } = props;
    const cancelButtonRef = useRef(null);
    const { t } = useTranslation();

    return (
        <Transition.Root show={isShown} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setShown}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-first-theme text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                <div className="bg-first-theme px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-white">
                                    <div className='text-center green-font text-3xl mb-8'>
                                        {t("To create an offer you need to be Verified using KYC")}
                                    </div>
                                    <div className='text-second-theme text-center mb-8'>
                                        {t("This is one time payment on your account")}
                                    </div>
                                    <div className='p-4 bg-black rounded-lg mb-8'>
                                        <div className='flex justify-between mb-4'>
                                            <span className='text-second-theme'>{t("KYC fee")}</span>
                                            <span>$5</span>
                                        </div>
                                        <div className='flex justify-between mb-4'>
                                            <span className='text-second-theme'>{t("Frequency")}</span>
                                            <span>One Time</span>
                                        </div>
                                        <div className='flex justify-between'>
                                            <span className='text-second-theme'>{t("Account")}</span>
                                            <span>2jgvp...5xMe4d</span>
                                        </div>
                                    </div>
                                    <div className=''>
                                        <div className="flex items-start mb-4">
                                            <input type="checkbox" className="green-font w-8 h-8 mr-2 focus:ring-green-400 focus:ring-opacity-25 border border-gray-300 rounded" />
                                            <label htmlFor="default-checkbox" className="ml-2 text-second-theme">{t("I agree for the above listed amount to be withdrawn from my account wallet")}</label>
                                        </div>
                                    </div>
                                    <div className='flex justify-between'>
                                        <GrayButton cssClass="w-5/12" title={t("Cancel")} size="lg" onClick={() => setShown(false)} />
                                        <GreenButton cssClass="w-5/12" title={t("Pay")} size="lg" onClick={handleCreateModal} />
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default CreateOfferModal;